import { render, staticRenderFns } from "./helpAndFeedback.vue?vue&type=template&id=248bff2c&scoped=true&lang=pug"
import script from "./helpAndFeedback.vue?vue&type=script&lang=ts"
export * from "./helpAndFeedback.vue?vue&type=script&lang=ts"
import style0 from "./helpAndFeedback.vue?vue&type=style&index=0&id=248bff2c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248bff2c",
  null
  
)

export default component.exports